import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtros) {
        let url = `${api}/credenciados/uabs/contratacoes?unidade=${filtros.unidade
            }&gestor=${filtros.gestor
            }&dataDe=${filtros.dataDe ? filtros.dataDe : ''
            }&dataAte=${filtros.dataAte ? filtros.dataAte : ''
            }&situacao=${filtros.situacao}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(contratacaoId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/contratacoes/${contratacaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarDespViagem(despViagemAtualizadaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${despViagemAtualizadaDto.codContratacao}/atualizardespviagem`,
                despViagemAtualizadaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterLimitesEntregaManual(contratacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/contratacoes/${contratacaoId}/limitesentregamanual`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirEntregaManual(entregaManual) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${entregaManual.codContratacao}/inserirentregamanual`,
                entregaManual
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirEntregaManual(codContratacao, entregaId) {
        return axiosJwt
            .delete(
                `${api}/credenciados/uabs/contratacoes/${codContratacao}/excluirentregamanual/${entregaId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/contratacoes/opcoesfiltros`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarDespViagem(despViagemCanceladaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${despViagemCanceladaDto.codContratacao}/cancelardespviagem`,
                despViagemCanceladaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desfazerCancelamentoDespViagem(despViagemCanceladaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${despViagemCanceladaDto.codContratacao}/desfazercancelamentodespviagem`,
                despViagemCanceladaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprogramarDespViagem(despViagemReprogramadaDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/contratacoes/${despViagemReprogramadaDto.codContratacao}/reprogramardespviagem`,
                despViagemReprogramadaDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
